import { render, staticRenderFns } from "./TagsSelector.vue?vue&type=template&id=92e5ea6c&scoped=true"
import script from "./TagsSelector.vue?vue&type=script&lang=js"
export * from "./TagsSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92e5ea6c",
  null
  
)

export default component.exports